import React from 'react';

import { FiCamera } from '@fmbt/ui/icons';

export default function FarmbotCameraIcon() {
  return <FiCamera size={18} />;
}
